<template>
  <div>
    <v-stepper v-model="e6" vertical elevation="0">
      <!-- <v-stepper-header>
      <v-stepper-step :complete="e6 > 1" editable step="1" edit-icon="$complete">Names</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e6 > 2" editable step="2" edit-icon="$complete">Business details</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e6 > 3" editable step="3" edit-icon="$complete">Information</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step editable step="4" edit-icon="$complete">Default order messages</v-stepper-step>
    </v-stepper-header>-->

      <v-stepper-step
        :complete="e6 > 1"
        editable
        step="1"
        edit-icon="$complete"
      >
        {{ $t("names") }}
        <small>{{ $t("namesHint") }}</small>
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-form ref="form" v-model="valid">
          <v-card-text>
            <v-card-title class="headline px-0">
              <span
                :class="
                  $vuetify.breakpoint.xs
                    ? 'black--text ellipsis'
                    : 'black--text'
                "
              >
                {{ $t("names") }}
              </span>
              <v-btn
                :class="$vuetify.breakpoint.xs ? 'ml-1' : 'ml-2'"
                color="primary"
                text
                rounded
                :small="$vuetify.breakpoint.xs"
                :disabled="!valid"
                @click="e6 = 2"
              >
                <span v-if="$vuetify.breakpoint.xs">
                  <v-icon>mdi-arrow-right</v-icon>
                </span>
                <span v-else>
                  {{ $t("continue") }}
                </span>
              </v-btn>
            </v-card-title>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="restaurant.names.name"
                  :label="`${$t('name')} *`"
                  placeholder="Demo restaurant"
                  :hint="$t('nameHint')"
                  :rules="[
                    (v) => !!v || $t('requiredField'),
                    namesAvailability.name !== false || $t('nameNotAvailable'),
                  ]"
                  @input="
                    isNameAvailable('name', restaurant.names.name);
                    generateUrlAndVoiceName(restaurant.names.name);
                  "
                  @blur="checkUrlAndVoiceName()"
                  :append-icon="
                    restaurant.names.name && namesAvailability.name
                      ? 'mdi-checkbox-marked-circle'
                      : namesAvailability.name === false
                      ? 'mdi-alert-circle'
                      : null
                  "
                  required
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="restaurant.names.urlName"
                  :label="`${$t('urlName')} *`"
                  placeholder="demo-restaurant"
                  :rules="[
                    (v) => !!v || $t('requiredField'),
                    (v) => /^[-a-z0-9]+$/.test(v) || $t('urlNameAllowedChars'),
                    namesAvailability.urlName !== false ||
                      $t('nameNotAvailable'),
                  ]"
                  @input="isNameAvailable('urlName', restaurant.names.urlName)"
                  :append-icon="
                    restaurant.names.urlName &&
                    /^[-a-z0-9]+$/.test(restaurant.names.urlName) &&
                    namesAvailability.urlName
                      ? 'mdi-checkbox-marked-circle'
                      : namesAvailability.urlName === false
                      ? 'mdi-alert-circle'
                      : null
                  "
                  rounded
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="restaurant.names.voiceName"
                  :label="`${$t('voiceName')} *`"
                  placeholder="Demo restaurant"
                  :rules="[
                    (v) => !!v || $t('requiredField'),
                    namesAvailability.voiceName !== false ||
                      $t('nameNotAvailable'),
                  ]"
                  @input="
                    isNameAvailable('voiceName', restaurant.names.voiceName)
                  "
                  :append-icon="
                    restaurant.names.voiceName && namesAvailability.voiceName
                      ? 'mdi-checkbox-marked-circle'
                      : namesAvailability.voiceName === false
                      ? 'mdi-alert-circle'
                      : null
                  "
                  rou
                  rounded
                  filled
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </v-stepper-content>

      <v-stepper-step
        :complete="e6 > 2"
        editable
        step="2"
        edit-icon="$complete"
      >
        {{ $t("businessDetails") }}
        <small>{{ $t("businessDetailsHint") }}</small>
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-card-text>
          <v-card-title class="headline px-0">
            <span
              :class="
                $vuetify.breakpoint.xs ? 'black--text ellipsis' : 'black--text'
              "
            >
              {{ $t("businessDetails") }}
            </span>
            <v-btn
              :class="$vuetify.breakpoint.xs ? 'ml-1' : 'ml-2'"
              color="primary"
              text
              rounded
              :small="$vuetify.breakpoint.xs"
              @click="e6 = 3"
            >
              <span v-if="$vuetify.breakpoint.xs">
                <v-icon>mdi-arrow-right</v-icon>
              </span>
              <span v-else>
                {{ $t("continue") }}
              </span>
            </v-btn>
          </v-card-title>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.legalName"
                :label="$t('legalName')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.businessId"
                :label="$t('businessId')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.taxId"
                :label="$t('taxId')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.vat"
                :label="$t('vat')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.address.street"
                :label="$t('street')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.address.city"
                :label="$t('city')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.address.zip"
                type="number"
                :label="$t('zip')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.businessDetails.address.state"
                :label="$t('state')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-stepper-content>

      <v-stepper-step
        :complete="e6 > 3"
        editable
        step="3"
        edit-icon="$complete"
      >
        {{ $t("information") }}
        <small>{{ $t("informationHint") }}</small>
      </v-stepper-step>
      <v-stepper-content step="3">
        <v-card-text>
          <v-card-title class="headline px-0">
            <span
              :class="
                $vuetify.breakpoint.xs ? 'black--text ellipsis' : 'black--text'
              "
            >
              {{ $t("information") }}
            </span>
            <v-btn
              :class="$vuetify.breakpoint.xs ? 'ml-1' : 'ml-2'"
              color="primary"
              text
              rounded
              :small="$vuetify.breakpoint.xs"
              @click="e6 = 4"
            >
              <span v-if="$vuetify.breakpoint.xs">
                <v-icon>mdi-arrow-right</v-icon>
              </span>
              <span v-else>
                {{ $t("continue") }}
              </span>
            </v-btn>
          </v-card-title>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="restaurant.info.contact.website"
                :label="$t('website')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="restaurant.info.contact.email"
                :label="$t('email')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="restaurant.info.contact.mobile"
                :label="$t('mobile')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.info.contact.address.street"
                :label="$t('street')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.info.contact.address.city"
                :label="$t('city')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.info.contact.address.zip"
                type="number"
                :label="$t('zip')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="restaurant.info.contact.address.state"
                :label="$t('state')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="restaurant.info.description"
                :label="$t('description')"
                auto-grow
                rounded
                filled
                hide-details
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('openingHours')"
                :hint="$t('openingHoursHint')"
                prepend-inner-icon="mdi-eye"
                readonly
                rounded
                filled
                persistent-hint
                @click:prepend-inner="dialog = true"
              >
                <v-icon style="vertical-align: middle">mdi-eye</v-icon>
                <template v-slot:label>
                  {{ $t("click") }}
                  <v-icon style="vertical-align: middle" small>mdi-eye</v-icon
                  >&#160;{{ $t("toShowOpeningHours") }}
                </template>
              </v-text-field>
              <v-dialog v-model="dialog" max-width="450" persistent>
                <v-card>
                  <v-card-title class="headline">{{
                    $t("openingHours")
                  }}</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-data-table
                            :headers="headers"
                            :header-props="{ sortByText: $t('sortBy') }"
                            :items="restaurant.info.openingHours"
                            hide-default-footer
                          >
                            <template v-slot:item.day="{ item }">
                              <v-chip v-if="item.day === 'monday'">{{
                                $t("monday")
                              }}</v-chip>
                              <v-chip v-if="item.day === 'tuesday'">{{
                                $t("tuesday")
                              }}</v-chip>
                              <v-chip v-if="item.day === 'wednesday'">{{
                                $t("wednesday")
                              }}</v-chip>
                              <v-chip v-if="item.day === 'thursday'">{{
                                $t("thursday")
                              }}</v-chip>
                              <v-chip v-if="item.day === 'friday'">{{
                                $t("friday")
                              }}</v-chip>
                              <v-chip v-if="item.day === 'saturday'">{{
                                $t("saturday")
                              }}</v-chip>
                              <v-chip v-if="item.day === 'sunday'">{{
                                $t("sunday")
                              }}</v-chip>
                            </template>
                            <template v-slot:item.from="props">
                              <v-edit-dialog
                                :return-value.sync="props.item.from"
                                large
                                :cancel-text="$t('close')"
                                :save-text="$t('save')"
                              >
                                <div>{{ props.item.from }}</div>
                                <!-- <template v-slot:input>
                                <div class="mt-4 title">Update time</div>
                              </template> -->
                                <template v-slot:input>
                                  <v-select
                                    menu-props="auto"
                                    :items="getOpeningHoursTimes()"
                                    style="margin-top: 16px"
                                    v-model="props.item.from"
                                    label="10:00"
                                    single-line
                                    filled
                                    rounded
                                    hide-details
                                  ></v-select>
                                </template>
                              </v-edit-dialog>
                            </template>
                            <template v-slot:item.to="props">
                              <v-edit-dialog
                                :return-value.sync="props.item.to"
                                large
                                :cancel-text="$t('close')"
                                :save-text="$t('save')"
                              >
                                <div>{{ props.item.to }}</div>
                                <!-- <template v-slot:input>
                                <div class="mt-4 title">Update time</div>
                              </template> -->
                                <template v-slot:input>
                                  <v-select
                                    menu-props="auto"
                                    :items="getOpeningHoursTimes()"
                                    style="margin-top: 16px"
                                    v-model="props.item.to"
                                    label="20:00"
                                    single-line
                                    filled
                                    rounded
                                    hide-details
                                  ></v-select>
                                </template>
                              </v-edit-dialog>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="primary" text rounded @click="dialog = false">Close</v-btn>
                  <v-btn color="success" text rounded @click="saveOpeningHours()">Save</v-btn>-->
                    <v-btn
                      color="primary"
                      text
                      rounded
                      @click="dialog = false"
                      >{{ $t("close") }}</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="restaurant.currency"
                :items="['EUR', 'CZK']"
                :label="$t('currency')"
                single-line
                filled
                rounded
                :hint="$t('currencyHint')"
                persistent-hint
                required
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </v-stepper-content>

      <v-stepper-step
        :complete="e6 > 4"
        editable
        step="4"
        edit-icon="$complete"
      >
        {{ $t("defaultOrderMessages") }}
        <small>{{ $t("defaultOrderMessagesHint") }}</small>
      </v-stepper-step>
      <v-stepper-content step="4">
        <v-card-text>
          <v-card-title class="headline px-0">
            <span
              :class="
                $vuetify.breakpoint.xs ? 'black--text ellipsis' : 'black--text'
              "
            >
              {{ $t("defaultOrderMessages") }}
            </span>
            <v-btn
              :class="$vuetify.breakpoint.xs ? 'ml-1' : 'ml-2'"
              color="primary"
              text
              rounded
              :small="$vuetify.breakpoint.xs"
              @click="e6 = 5"
            >
              <span v-if="$vuetify.breakpoint.xs">
                <v-icon>mdi-arrow-right</v-icon>
              </span>
              <span v-else>
                {{ $t("continue") }}
              </span>
            </v-btn>
          </v-card-title>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="restaurant.defaultMessages.confirmation.subject"
                :label="$t('confirmationSubject')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="restaurant.defaultMessages.confirmation.message"
                :label="$t('confirmationMessage')"
                auto-grow
                rounded
                filled
                :hint="$t('confirmationMessageHint')"
                persistent-hint
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="restaurant.defaultMessages.rejection.subject"
                :label="$t('rejectionSubject')"
                rounded
                filled
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="restaurant.defaultMessages.rejection.message"
                :label="$t('rejectionMessage')"
                auto-grow
                rounded
                filled
                hide-details
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-stepper-content>

      <v-stepper-step editable step="5" edit-icon="$complete">
        {{ $t("agreements") }}
        <small>{{ $t("agreementsHint") }}</small>
      </v-stepper-step>
      <v-stepper-content step="5">
        <v-card-text>
          <v-card-title class="headline px-0">
            <span
              :class="
                $vuetify.breakpoint.xs ? 'black--text ellipsis' : 'black--text'
              "
            >
              {{ $t("agreements") }}
            </span>
            <v-btn
              :class="$vuetify.breakpoint.xs ? 'ml-1' : 'ml-2'"
              color="success"
              text
              rounded
              :disabled="!(valid && agreementCheckbox)"
              @click="createRestaurant()"
            >
              {{ $t("create") }}
            </v-btn>
          </v-card-title>
          <v-row>
            <v-col cols="12">
              <v-checkbox
                v-model="agreementCheckbox"
                class="pa-0 ma-0 mb-4"
                hide-details
                color="primary"
              >
                <template v-slot:label>
                  <div>
                    {{ $t("iAgreeWith") }}
                    <a
                      class="primary--text text-decoration-none"
                      style="text-decoration: none !important"
                      href="https://piknik.cc/vop"
                      target="_blank"
                      @click.stop
                      rel="noopener noreferrer"
                      >{{ $t("commercialTerms") }}</a
                    >.
                  </div>
                </template></v-checkbox
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-stepper-content>
    </v-stepper>
    <div id="whatsapp"></div>
  </div>
</template>

<script>
import restaurantService from "../services/restaurant.service";

export default {
  data() {
    return {
      loading: true,
      valid: true,
      timeout: null,
      timeout2: null,
      namesAvailability: {
        name: null,
        urlName: null,
        voiceName: null,
      },
      agreementCheckbox: false,
      e6: 1,
      dialog: false,
      headers: [
        { text: this.$t("day"), value: "day", sortable: false },
        { text: this.$t("from"), value: "from", sortable: false },
        { text: this.$t("to"), value: "to", sortable: false },
      ],
      defaultOpeningHours: [
        {
          day: "monday",
          from: "14:00",
          to: "20:00",
        },
        {
          day: "tuesday",
          from: "14:00",
          to: "20:00",
        },
        {
          day: "wednesday",
          from: "14:00",
          to: "20:00",
        },
        {
          day: "thursday",
          from: "14:00",
          to: "20:00",
        },
        {
          day: "friday",
          from: "14:00",
          to: "20:00",
        },
        {
          day: "saturday",
          from: "14:00",
          to: "20:00",
        },
        {
          day: "sunday",
          from: "14:00",
          to: "20:00",
        },
      ],
      account: {
        info: {
          firstName: null,
          lastName: null,
          mobile: null,
        },
        email: null,
        currentPassword: null,
        newPassword: null,
      },
      restaurant: {
        businessDetails: {
          legalName: null,
          businessId: null,
          taxId: null,
          vat: null,
          address: {
            street: null,
            city: null,
            zip: null,
            state: null,
          },
        },
        names: {
          name: null,
          urlName: null,
          voiceName: null,
        },
        info: {
          openingHours: [],
          description: null,
          contact: {
            website: null,
            email: null,
            mobile: null,
            address: {
              street: null,
              city: null,
              zip: null,
              state: null,
            },
          },
        },
        defaultMessages: {
          confirmation: {
            subject: this.$t("confirmationSubjectContent"),
            message: this.$t("confirmationMessageContent"),
          },
          rejection: {
            subject: this.$t("rejectionSubjectContent"),
            message: this.$t("rejectionMessageContent"),
          },
        },
        currency: "EUR",
        defaultLanguage: this.$i18n.locale,
      },
    };
  },
  created() {
    if (
      !this.restaurant.info.openingHours ||
      this.restaurant.info.openingHours.length === 0
    )
      this.restaurant.info.openingHours = this.defaultOpeningHours;
  },
  mounted() {
    $("#whatsapp").venomButton({
      phone: "+421950466441",
      avatar:
        "https://cdn.jsdelivr.net/gh/sjasik/piknik.cc@latest/images/whatsapp/avatar.png",
      buttonImage:
        "https://cdn.jsdelivr.net/gh/sjasik/piknik.cc@latest/images/whatsapp/icon.svg",
      nameClient: "Piknik",
      headerTitle: this.$t("usuallyRepliesWithinTheHour"),
      chatMessage: this.$t("whatsappChatMessageCreate"),
      placeholder: this.$t("yourMessage"),
      showPopup: true,
      position: "right",
      size: "64px",
      buttonColor: "#25D366",
    });
    setTimeout(() => {
      $("#whatsapp .venom-button-popup").addClass("active");
    }, 2500);
  },
  methods: {
    getOpeningHoursTimes() {
      const x = 15;
      let times = [];
      let tt = 0;

      for (let i = 0; tt <= 24 * 60; i++) {
        let hh = Math.floor(tt / 60);
        let mm = tt % 60;
        times[i] = ("0" + hh).slice(-2) + ":" + ("0" + mm).slice(-2);
        tt = tt + x;
      }
      return times;
    },
    generateUrlAndVoiceName(name) {
      this.restaurant.names.urlName = name
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[^\w]/g, "");
      this.restaurant.names.voiceName = name;
    },
    isNameAvailable: async function (nameType, nameValue) {
      clearTimeout(this.timeout);
      const self = this;
      this.timeout = setTimeout(async function () {
        const available = await restaurantService.isNameAvailable(
          nameType,
          nameValue
        );
        self.namesAvailability[nameType] = available;
      }, 1000);
    },
    async checkUrlAndVoiceName() {
      clearTimeout(this.timeout2);
      const self = this;
      this.timeout2 = setTimeout(async function () {
        const availableUrlName = await restaurantService.isNameAvailable(
          "urlName",
          self.restaurant.names.urlName
        );
        const availableVoiceName = await restaurantService.isNameAvailable(
          "voiceName",
          self.restaurant.names.voiceName
        );
        self.namesAvailability.urlName = availableUrlName;
        self.namesAvailability.voiceName = availableVoiceName;
      }, 1000);
    },
    async createRestaurant() {
      Object.keys(this.restaurant.names).forEach(
        (key) =>
          this.restaurant.names[key] == null &&
          delete this.restaurant.names[key]
      );

      const newRestaurant = await restaurantService.createRestaurant(
        this.restaurant
      );

      if (newRestaurant) {
        try {
          gtag("event", "restaurant_creation");
        } catch (e) {
          console.log("Tracking disabled");
        }

        if (!localStorage.access) localStorage.access = JSON.stringify([]);
        let access = JSON.parse(localStorage.access);
        access.push(newRestaurant);
        localStorage.access = JSON.stringify(access);
        localStorage.restaurantId = newRestaurant.restaurantId;
        this.$router.push("/dashboard");
      }
    },
  },
};
</script>

<style>
.v-small-dialog__actions .v-btn:nth-child(2) {
  color: #13e46d !important;
}

.v-small-dialog__actions .v-btn {
  border-radius: 28px;
}

.v-stepper .v-card__text {
  padding-top: 0px;
}

.v-stepper {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.headline .ellipsis {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
